import { render, staticRenderFns } from "./ThumbnailSlider.vue?vue&type=template&id=6ffb606d&scoped=true&"
import script from "./ThumbnailSlider.vue?vue&type=script&lang=js&"
export * from "./ThumbnailSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffb606d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ffb606d')) {
      api.createRecord('6ffb606d', component.options)
    } else {
      api.reload('6ffb606d', component.options)
    }
    module.hot.accept("./ThumbnailSlider.vue?vue&type=template&id=6ffb606d&scoped=true&", function () {
      api.rerender('6ffb606d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ThumbnailSlider.vue"
export default component.exports